module.exports = __webpack_public_path__ + "img/78.f8af7d8a.jpg";